/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectionStrategy, ChangeDetectorRef, Component, TemplateRef } from '@angular/core';
import { IRowNode } from 'ag-grid-community';

import {
  GridRowInitParams,
  GridRowOptionsComponent,
  GridRowParams,
} from './grid-row-options-component';

@Component({
  standalone: false,
  selector: 'gh-template-based-option-bar',
  template: `
    <ng-container [ngTemplateOutlet]='templateRef'
                  [ngTemplateOutletContext]='{ $implicit: node.data, node: node }'></ng-container>`,
  host: {
    'class': 'row-overlay',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GridTemplateBasedOptionBarComponent implements GridRowOptionsComponent {
  templateRef: TemplateRef<any>;
  node: IRowNode;

  constructor(private changeDetectorRef: ChangeDetectorRef) {

  }

  setTemplateRef(templateRef: TemplateRef<any>): void {
    this.templateRef = templateRef;
  }

  initRowOptions(row: GridRowInitParams): void {
    this.node = row.node;

    this.changeDetectorRef.detectChanges();
  }

  refresh(row: GridRowParams): void {
    this.node = row.node;

    this.changeDetectorRef.markForCheck();
  }
}
